import { Loading } from "@/components/common/Loading";
import { Protected } from "@/components/layout/Protected";
import { RecetaService } from "@/service/services/Receta.service";
import { Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ModalConfirm } from "@/components/common/ModalConfirm/ModalConfirm";
import { RecetaModal } from "./RecetaModal";

export const Receta: FC = () => {

    const params: { id: string } = useParams()
    const { id } = params
    const history = useHistory()

    const [loading, setLoading] = useState<boolean>(false)
    const [insumos, setInsumos] = useState<any[]>([])
    const [nombreProducto, setNombreProducto] = useState<string>('')
    const [action, setAction] = useState<string>('')
    const [rowSelected, setRowSelected] = useState<any>(null)
    const [showModalReceta, setShowModalReceta] = useState<boolean>(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [showModalDelete, setShowModalDelete] = useState<boolean>(false)
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)

    useEffect(() => {
        getRecetaAPI()
    }, [])

    const getRecetaAPI = async () => {
        setLoading(true)
        const response = await RecetaService.getRecetas({ idproducto: id })
        if (response.data) {
            setNombreProducto(response.data[0]?.producto || '')
            setInsumos(response.data || [])
        }
        setLoading(false)
    }

    const goBack = () => {
        history.push('/mis-productos');
    };

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalDelete(true)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const confirmDelete = async () => {
        setLoadingSubmit(true)
        await RecetaService.deleteInsumo(rowSelected.id)
        getRecetaAPI()
        setShowModalDelete(false)
        setLoadingSubmit(false)
    }

    return (<Protected>
        {loading && <Loading />}
        <Grid container spacing={2}>
            <Grid item xs={12} display='flex' alignItems='center'>
                <Grid className="btn-back-container" onClick={goBack} sx={{ cursor: 'pointer', border: '1px solid #188dcd', borderRadius: '4px', padding: '8px', display: 'flex', alignItems: 'center' }}>
                    <ArrowCircleLeftIcon fontSize='small' sx={{ color: '#188dcd', marginRight: '2px' }} />
                    <Typography className='btn-back-text'>Volver</Typography>
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h4">RECETA: {nombreProducto}</Typography>
                </Grid>
            </Grid>
            <Grid item container xs={12}
                sx={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginBottom: "10px",
                }}
            >
                <Grid item>

                </Grid>
                <Grid
                    item
                    sx={{ textAlign: "right" }}
                >
                    <Button
                        onClick={() => {
                            setAction('create');
                            setRowSelected(null);
                            setShowModalReceta(true)
                        }}
                        sx={{
                            border: "solid 1px #73B2FF",
                            mt: "10px",
                            color: "#73B2FF",
                            "&:hover": {
                                bgcolor: "#73B2FF",
                                color: "#fff",
                            },
                        }}
                    >
                        Agregar insumo
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{`N°`}</TableCell>
                                <TableCell align="left">Código</TableCell>
                                <TableCell align="left">Insumo</TableCell>
                                <TableCell align="left">Cantidad</TableCell>
                                <TableCell align="center">Opciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {insumos?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((insumo, index) =>
                                <TableRow key={index}>
                                    <TableCell align="left">{index + 1 + page * rowsPerPage}</TableCell>
                                    <TableCell align="left">{insumo.codigo_insumo}</TableCell>
                                    <TableCell align="left">{insumo.insumo}</TableCell>
                                    <TableCell align="left">{insumo.cantidad}</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title={"Editar codigo de barras"}>
                                            <IconButton onClick={() => { setAction('edit'); setRowSelected(insumo); setShowModalReceta(true) }}>
                                                <EditIcon color="primary" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={"Eliminar codigo de barras"}>
                                            <IconButton onClick={() => onDelete(insumo)}>
                                                <DeleteIcon color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[20, 30, 40]}
                    component="div"
                    count={insumos?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Grid>
        </Grid>
        {showModalDelete &&
            <ModalConfirm
                open={showModalDelete}
                closeModal={() => setShowModalDelete(false)}
                onCancel={() => setShowModalDelete(false)}
                onConfirm={confirmDelete}
                status2={loadingSubmit}
                title={"¿Esta seguro de eliminar el insumo de la receta?"}
            />
        }
        {showModalReceta &&
            <RecetaModal
                open={showModalReceta}
                setOpenPopup={setShowModalReceta}
                action={action}
                onList={getRecetaAPI}
                rowSelected={rowSelected}
                idproducto={parseInt(id)}
            />
        }
    </Protected>)
}